import styled from 'styled-components'
import { flexbox, layout, margin, padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.attrs({
  pt: [6, 6, 6, 16],
  pb: ['80px', '80px', '100px', '120px'],
  px: LANDING_INLINE_PADDINGS,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.default')};
  position: relative;

  ${padding}
`

export const Content = styled.div
  .attrs({
    flexDirection: ['column', 'column', 'column', 'column', 'column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  max-width: ${BLUEPRINT_WIDTH}px;
  position: relative;
  width: 100%;
  z-index: 11;

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    > div:first-child {
      align-self: flex-start;
      position: sticky;
      top: 72px;
      width: 100%;
    }
  }

  ${flexbox}
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${margin}
`

export const Card = styled.div.attrs({
  pt: [7, 7, 9],
  px: [7, 7, 9, 9, 9, 11],
  pb: [7, 7, 9, 9, 9, 8],
})`
  background-color: ${themeGet('colors.bg.default')};
  border-radius: 20px;
  position: relative;
  border: 1px solid ${themeGet('colors.pinkAmaranthDull')};

  ${padding}
`

export const SquaresHolder = styled.div.attrs({
  display: ['none', 'none', 'none', 'none', 'flex'],
})`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;

  ${layout}
`
